import GreenbeltInfo from 'src/components/PropertyTypeInfo/GreenbeltInfo';
import MotorVehicleInfo from 'src/components/PropertyTypeInfo/MotorVehicleInfo';
import PersonalPropertyInfo from 'src/components/PropertyTypeInfo/PersonalPropertyInfo';
import RealPropertyInfo from 'src/components/PropertyTypeInfo/RealPropertyInfo';

export default function PropertyTypeInfo({ type = '' }) {
  return (
    <>
      {type === 'real' && <RealPropertyInfo title={'Real Property'} />}
      {type === 'personal' && <PersonalPropertyInfo />}
      {type === 'greenbelt' && <GreenbeltInfo title={'Greenbelt'} />}
      {type === 'vehicle' && <MotorVehicleInfo title={'Motor Vehicle'} />}
    </>
  );
}
